
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";

    @Component
    export default class SectionRequirements extends Vue {
        @Prop({default:true, required:true})
        disableApplicationRequirement! : boolean; 
    }
